import { AxiosError } from "axios";

export default function ThrowsAccessDenied(): MethodDecorator {
    return function (target: object, key: string | symbol, descriptor: PropertyDescriptor) {
        if (descriptor === undefined) {
            descriptor = Object.getOwnPropertyDescriptor(target, key);
        }
        const originalMethod: (...args: unknown[]) => Promise<unknown> = descriptor.value;


        descriptor.value = function (...args: unknown[]) {
            return Reflect.apply(originalMethod, this, args)
                .catch(function (error: unknown) {
                    if (error instanceof AxiosError) {
                        const response = error.response;

                        if (response.status === 403) {
                            throw new AccessDeniedError();
                        }

                    }
                    throw error;
                });
        }
    }
}

export class AccessDeniedError extends Error {
    constructor() {
        super("Access denied");
    }
}